import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@smile-next/uikit';
import { LoginFormButton } from '@/components/LoginForm/LoginFormButton';
import { LoginFormTextField } from '@/components/LoginForm/LoginFormTextField';
import { AuthParams } from '@/models/domain/AuthParams';
import { CloudId } from '@/models/domain/CloudId';

type Props = {
    authParams?: AuthParams;
    onClickNextIdLoginButton: (authParams: AuthParams) => void;
    onClickSSOButton: (authParams: AuthParams) => void;
};

const useStyles = makeStyles((theme) => ({
    root: {},
    itemMargin: {
        marginTop: theme.spacing(4),
    },
}));

export const SelectLoginMethodForm: React.FC<Props> = (props) => {
    const { authParams: inputAuthParams, onClickNextIdLoginButton, onClickSSOButton } = props;
    const [authParams, setAuthParams] = useState<AuthParams | undefined>(inputAuthParams);
    const [cloudIdErrorMessage, setCloudIdErrorMessage] = useState<string>('');
    const classes = useStyles();

    useEffect(() => {
        // propsで渡ってくるauthParamsはusecase経由でrepositoryから取得しており、
        // 取得できたら変更される事があるため、変化があったら更新を行う。
        setAuthParams(inputAuthParams);
    }, [inputAuthParams]);

    const onInputCloudId = useCallback(
        (inputValue: string) => {
            setAuthParams(authParams?.updateCloudId(new CloudId({ value: inputValue })));
        },
        [authParams],
    );

    const onChangeCloudId = useCallback((inputValue: string) => {
        const result = CloudId.RULES.find((rule) => {
            return rule(inputValue) !== true;
        });

        if (result && inputValue) {
            setCloudIdErrorMessage(result(inputValue) as string);
        } else {
            setCloudIdErrorMessage('');
        }
    }, []);

    const handleClickNextIdLogin = useCallback(() => {
        // 設定値のバリデーションメッセージを格納する
        if (authParams?.cloudId) {
            setCloudIdErrorMessage(authParams.cloudId.validationMessage);
        }

        // 設定値のバリデーションチェックを行う
        if (!authParams?.cloudId || !authParams.cloudId.isValid) {
            return;
        }
        onClickNextIdLoginButton(authParams);
    }, [authParams, onClickNextIdLoginButton]);

    const handleClickSSOButton = useCallback(() => {
        // 設定値のバリデーションメッセージを格納する
        if (authParams?.cloudId) {
            setCloudIdErrorMessage(authParams.cloudId.validationMessage);
        }

        // 設定値のバリデーションチェックを行う
        if (!authParams?.cloudId || !authParams.cloudId.isValid) {
            return;
        }
        onClickSSOButton(authParams);
    }, [authParams, onClickSSOButton]);

    return (
        <div className={classes.root}>
            <LoginFormTextField
                errorMessage={cloudIdErrorMessage}
                keepMessageSpace
                label="クラウドID"
                value={authParams?.cloudId?.value || ''}
                onChange={onChangeCloudId}
                onInput={onInputCloudId}
            />
            <LoginFormButton onClick={handleClickNextIdLogin}>ログインIDとパスワードでログイン</LoginFormButton>
            <div className={classes.itemMargin}>
                <LoginFormButton onClick={handleClickSSOButton}>シングルサインオン</LoginFormButton>
            </div>
        </div>
    );
};
